import AdminClient from "../apis/adminClient";
const adminClient = new AdminClient();

const state = {
  noticeList: [],
  noticePage: null,
  noticePageTotal: 0,
  noticeTotalElemtnts: 0,

  noticeDetail: {
    noticeTitle: "",
    noticeContent: "",
    noticeFile: [],
    regDate: new Date()
  }
};

const getters = {
  getNoticeList(state) {
    return state.noticeList;
  },

  getNoticePage(state) {
    if (state.noticePage === null) {
      return 0;
    } else {
      return state.noticePage.pageNumber + 1;
    }
  },
  getNoticePageTotal(state) {
    return state.noticePageTotal;
  },
  getNoticeTotalElements(state) {
    return state.noticeTotalElemtnts;
  },
  getNoticeDetail(state) {
    return state.noticeDetail;
  }
};

const mutations = {
  NOTICE_LIST(state, data) {
    state.noticeList = data.resultNoticeList;
    state.noticePage = data.page;
    state.noticePageTotal = data.pageTotal;
    state.noticeTotalElemtnts = data.totalElemtnts;
  },
  NOTICE_LIST_ADD(state, data) {
    state.noticeList = [].concat.apply(state.noticeList, data.resultNoticeList);
    state.noticePage = data.page;
    state.noticePageTotal = data.pageTotal;
    state.noticeTotalElemtnts = data.totalElemtnts;
  },
  NOTICE_DETAIL(state, data) {
    state.noticeDetail = data.resultNotice;
  },
  NOTICE_INIT(state) {
    state.noticeList = [];
    state.noticePage = null;
    state.noticePageTotal = 0;
    state.noticeTotalElemtnts = 0;

    state.noticeDetail = {
      noticeTitle: "",
      noticeContent: "",
      noticeFile: [],
      regDate: new Date()
    };
  }
};

const actions = {
  async REQUEST_NOTICE_LIST({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const data = await adminClient.getNoticeList(parameter);

      if (data?.result !== "success") {
        return alert(data.message);
      }

      if (data.page.pageNumber !== 0) {
        return commit("NOTICE_LIST_ADD", data);
      }
      commit("NOTICE_LIST", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }
    } finally {
      commit("END_LOADING");
    }
  },
  // new
  async REQUEST_NOTICE_DETAIL({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const data = await adminClient.getNoticeDetail(parameter.id);

      if (data?.result !== "success") {
        alert(data.message);
        return false;
      }
      commit("NOTICE_DETAIL", data);
      return true;
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      return false;
    } finally {
      commit("END_LOADING");
    }
  }
};

export default { mutations, state, actions, getters };
